/** Shopify CDN FIXED ES5 VERSION **/

try {
  
    var productimgcontainer = document.querySelector(".product-information__media .product-media-constraint-wrapper");

    var newDiv = document.createElement("div");
    newDiv.classList.add("color-disclaimer");

    var para = document.createElement("p");
    para.innerHTML = "Actual colours may vary a little due to lighting and screens.<br> But your WOTTA bottle will still be gorgeous";

    newDiv.appendChild(para);
    productimgcontainer.appendChild(newDiv);

} catch (error) {
    console.log(error.message);
}

try {

    var colors = ["#b3ebf2","#ffc0cb","#ff0000","#625d7f","#c3b358","#000000","#ac8979","#392b20","#c3b294","#63721d","#283040","#0f5d4e","#ba8c02","#b6bb06"];

    var cap    = document.querySelector(".color-overlay-cap");
    var loop   = document.querySelector(".color-overlay-loop");
    var body   = document.querySelector(".color-overlay-body");
    var bumper = document.querySelector(".color-overlay-bumper");

    var index = 0;

    function colorchanger() {
        
        cap.style.backgroundColor    = colors[index % colors.length];
        loop.style.backgroundColor   = colors[(index + 1) % colors.length];
        body.style.backgroundColor   = colors[(index + 2) % colors.length];
        bumper.style.backgroundColor = colors[(index + 3) % colors.length];
        index++;
    }

    colorchanger();
    setInterval(colorchanger, 1000);

} catch (error) {
    console.log(error.message);
}

try {

    var customizeRadio = document.querySelector(
        'input[data-option-value-id="3427236085854"]'
    );

    if (customizeRadio) {
        customizeRadio.addEventListener("change", function () {
            console.log("Customize selected!");
            myFunction(); // run user function
        });
    }

} catch (error) {
    console.log(error.message);
}


try {


// Simple Dynamic Price Updater
let componentPrices = {
    Lid: 0,
    Loop: 0, 
    Bottom: 0
};

window.onload = function() {
    const btn = document.querySelector(".ptc_button");
    if (btn) {
        btn.addEventListener("click", function() {
            if (!btn.classList.contains("pplr_remove")) {
                setTimeout(initPriceSystem, 1500);
            }
        });
    }
}

function initPriceSystem() {
        
    // Set initial defaults to 0
    ['Lid', 'Loop', 'Bottom'].forEach(comp => {
        const selected = document.querySelector(`span[name="properties[${comp}]"].selected`);
        if (selected) {
            const defaultValue = selected.getAttribute('data-val');
            const defaultPrice = 0; // Defaults are free
            
            selected.setAttribute('data-default-value', defaultValue);
            selected.setAttribute('data-pplr_price', '0');
            
            componentPrices[comp] = 0;
            
        }
        
        // Add click listeners
        addComponentListener(comp);
    });
    
    updateTotalPrice();
}

function addComponentListener(component) {
    const options = document.querySelectorAll(`span[name="properties[${component}]"]`);
    
    options.forEach(option => {
        const newOption = option.cloneNode(true);
        option.parentNode.replaceChild(newOption, option);
        
        newOption.addEventListener('click', function() {
            const value = this.getAttribute('data-val');
            const defaultAttr = this.getAttribute('data-default-value');
            const isDefault = (value === defaultAttr);
            
            // Get original price from original attribute or data
            const originalPrice = parseFloat(this.getAttribute('data-original-price') || 
                                            this.getAttribute('data-pplr_price')) || 0;
            
            // Set price: 0 if default, original price if not
            const finalPrice = isDefault ? 0 : originalPrice;
            componentPrices[component] = finalPrice;
            
            
            
            // Update display after short delay
            setTimeout(updateTotalPrice, 100);
        });
    });
}

function updateTotalPrice() {
    const basePrice = 59.00;
    let total = basePrice;
    
    // Add component prices
    Object.keys(componentPrices).forEach(comp => {
        total += componentPrices[comp];
    });
    
    
    
    // Update cart display
    const priceElement = document.querySelector('.a_pplr_item_price');
    if (priceElement) {
        const newPrice = `$${total.toFixed(2)} AUD`;
        priceElement.textContent = newPrice;
        priceElement.setAttribute('value', newPrice);
        priceElement.setAttribute('pplr_set_price', newPrice);
        
        // Flash effect
        priceElement.classList.add('price-updated');
        setTimeout(() => {
            priceElement.classList.remove('price-updated');
        }, 1000);
    }
}


}
catch(error) {
    console.log("error =====>");
    console.log(error.message);
}



try {

document.addEventListener('DOMContentLoaded', function() {
  // Intercept add to cart form submission
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    // Check if this is an add-to-cart form
    if (form && form.action && form.action.includes('/cart/add')) {
      
      // Find all Zepto personalization inputs
      const zeptoInputs = form.querySelectorAll('input[name^="properties["]');
      
      // Debug: Log what we found
      console.log('Zepto inputs found:', zeptoInputs.length);
      zeptoInputs.forEach(input => {
        console.log(input.name, '=', input.value);
      });
      
      // Ensure all required Zepto inputs are present and have values
      const requiredProperties = ['properties[Bottle]', 'properties[Lid]', 'properties[Loop]', 'properties[Bumper]'];
      
      requiredProperties.forEach(propName => {
        const existingInput = form.querySelector(`input[name="${propName}"]`);
        
        if (!existingInput) {
          // Create hidden input if missing
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = propName;
          hiddenInput.value = 'blank'; // Default value
          form.appendChild(hiddenInput);
          console.log('Added missing input:', propName);
        } else if (!existingInput.value) {
          // Set default value if empty
          existingInput.value = 'blank';
          console.log('Set empty input:', propName);
        }
      });
    }
  });
  
  // Also handle AJAX add to cart if your theme uses it
  if (typeof Shopify !== 'undefined') {
    const originalAddItem = Shopify.addItem || function() {};
    
    Shopify.addItem = function(formId, callback) {
      const form = document.getElementById(formId);
      if (form) {
        // Ensure Zepto properties are included
        ensureZeptoProperties(form);
      }
      return originalAddItem.apply(this, arguments);
    };
  }
  
  function ensureZeptoProperties(form) {
    // Check all Zepto property inputs
    const zeptoInputs = form.querySelectorAll('[data_name]');
    
    zeptoInputs.forEach(input => {
      const propName = input.getAttribute('data_name');
      if (propName) {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = `properties[${propName}]`;
        hiddenInput.value = input.value || 'blank';
        
        // Remove any existing duplicate
        const existing = form.querySelector(`input[name="properties[${propName}]"]`);
        if (existing) existing.remove();
        
        form.appendChild(hiddenInput);
      }
    });
  }
});

    
} catch (error) {
    
}

try {

// Debug script - add to theme.liquid
document.addEventListener('DOMContentLoaded', function() {
  console.log('Zepto Debug Mode Enabled');
  
  // Monitor all form submissions
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    if (form && form.action && form.action.includes('/cart/add')) {
      console.log('=== ADD TO CART FORM DETECTED ===');
      
      // Log all form data
      const formData = new FormData(form);
      console.log('Form action:', form.action);
      console.log('Form method:', form.method);
      
      // Log all inputs
      const inputs = form.querySelectorAll('input, select, textarea');
      console.log('Total inputs:', inputs.length);
      
      // Log Zepto-specific inputs
      const zeptoInputs = form.querySelectorAll('[name^="properties["], [data_name]');
      console.log('Zepto-related inputs:', zeptoInputs.length);
      
      zeptoInputs.forEach(input => {
        console.log('Input:', input.name || input.getAttribute('data_name'), 
                   'Value:', input.value, 
                   'Type:', input.type,
                   'Element:', input);
      });
      
      // Log FormData entries
      for (let pair of formData.entries()) {
        console.log('FormData:', pair[0], '=', pair[1]);
      }
      
      console.log('=== END FORM DEBUG ===');
    }
  });
});

} catch (error) {
    
}

try {
(function() {
  console.log('Personalized image script starting...');
  
  const yourImageUrl = 'https://cdn.shopify.com/s/files/1/0631/8863/1646/files/cust.png?v=1764679881';
  
  // Function to replace icons
  function replaceIcons() {
    console.log('Attempting to replace icons...');
    
    // Method 1: Find by SVG content
    const svgs = document.querySelectorAll('svg');
    svgs.forEach(svg => {
      const path = svg.querySelector('path[d*="M1.5 4A2.5"]');
      if (path) {
        const container = svg.closest('[role="row"]');
        if (container && container.textContent.includes('Bottle:')) {
          console.log('Found personalized product SVG');
          
          // Create image
          const img = document.createElement('img');
          img.src = yourImageUrl;
          img.alt = 'Personalized';
          img.style.cssText = 'width:100%;height:100%;object-fit:contain;border-radius:4px;';
          
          // Replace the entire parent div
          const parentDiv = svg.closest('._1m6j2n3i, ._6zbcq523');
          if (parentDiv) {
            parentDiv.innerHTML = '';
            parentDiv.appendChild(img);
            console.log('Replaced SVG with image');
          }
        }
      }
    });
    
    // Method 2: Find by class pattern
    const iconContainers = document.querySelectorAll('[class*="n3i"]');
    iconContainers.forEach(container => {
      if (container.innerHTML.includes('svg') && !container.innerHTML.includes('img')) {
        const row = container.closest('[role="row"]');
        if (row && row.textContent.includes('Bottle:')) {
          container.innerHTML = `<img src="${yourImageUrl}" style="width:100%;height:100%;object-fit:contain;">`;
        }
      }
    });
  }
  
  // Run immediately
  setTimeout(replaceIcons, 2000);
  
  // Run every 2 seconds
  setInterval(replaceIcons, 2000);
  
  // Use MutationObserver to detect changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        setTimeout(replaceIcons, 500);
      }
    });
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  console.log('Script loaded and observing...');
})();

  
} catch (error) {
  console.log("error"+error.message);
}



try {

(function () {
  const observer = new MutationObserver(() => {
  const perButton = document.querySelector(".pplr-c-button");

    if (perButton) {
      console.log("Button found!");

      // Your code here
      perButton.addEventListener("click", () => {
        console.log("Button clicked");
      });

      observer.disconnect(); // stop observing
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

  
} catch (error) {
  console.log("Errrrrrrrror is"+error.message)
}


try {
  document.addEventListener("DOMContentLoaded", function () {
    console.log("--------------"+"Product page detected");

    // ✅ Run ONLY for this product
    if (!window.location.pathname.includes("personalised-bottle")) return;
      console.log("--------------"+"Personalised bottle page detected");

    const triggerPersonalizer = setInterval(() => {
      const personalizeBtn = document.querySelector("button.ptc_button");

      if (personalizeBtn && typeof window.cstmfy_personalize_text === "function") {
        console.log("Triggering personalizer");
        window.cstmfy_personalize_text(personalizeBtn, new Event("click"));
        clearInterval(triggerPersonalizer);
      }
    }, 300);

  });
} catch (error) {
  console.error("Personalizer auto-open error:", error);
}


try {
(function () {
  const TARGET_SELECTOR = "header-actions";
  const CUSTOM_CLASS = "custom-shop";

  function inject() {
    const headerActions = document.querySelector(TARGET_SELECTOR);
    if (!headerActions) return;

    if (headerActions.querySelector("." + CUSTOM_CLASS)) return;

    const wrapper = document.createElement("div");
    wrapper.className = CUSTOM_CLASS;
    wrapper.innerHTML = `
      <div class="headerShop">SHOP</div>
      <ul class="shop-menu">
        <li><a href="/collections/complete-botlle-set">BOTTLES</a></li>
        <li><a href="/collections/lids">LIDS</a></li>
        <li><a href="/collections/loops">LOOPS</a></li>
        <li><a href="/collections/bumpers">BUMPERS</a></li>
      </ul>
    `;

    headerActions.prepend(wrapper);

    const shopBtn = wrapper.querySelector(".headerShop");
    const menu = wrapper.querySelector(".shop-menu");

    menu.style.display = "none";

    shopBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      menu.style.display = menu.style.display === "block" ? "none" : "block";
    });

    // close when clicking outside
    document.addEventListener("click", () => {
      menu.style.display = "none";
    });

    console.log("✅ SHOP menu injected");
  }

  const interval = setInterval(inject, 300);
  setTimeout(() => clearInterval(interval), 8000);
})();


} catch (error) {
  console.log("this is error "+ error.message)
}